import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Impressum = () => {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <header className="border-b border-[#E2E8F0]">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <Link to="/" className="inline-flex items-center gap-2 text-[#1E40AF] hover:text-[#1E3A8A] transition-colors">
            <ArrowLeft size={20} />
            <span className="font-medium">Zurück zur Startseite</span>
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-5xl font-bold text-black mb-12">Impressum</h1>

        <div className="space-y-8 text-gray-600 leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-black mb-4">Angaben gemäß § 5 TMG</h2>
            <p>
              Tolga Akin<br />
              Dahlienstr. 2<br />
              65451 Kelsterbach
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">Kontakt</h2>
            <p>
              Telefon: 0173 5220787<br />
              E-Mail: kontakt@webwerk-kelsterbach.de
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">Umsatzsteuer-ID</h2>
            <p>
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              DE 744592860638
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p>
              Tolga Akin<br />
              Dahlienstr. 2<br />
              65451 Kelsterbach
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">EU-Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#1E40AF] underline hover:text-[#1E3A8A]">
                https://ec.europa.eu/consumers/odr/
              </a>
              .<br />
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-black mb-4">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>
        </div>
      </main>

      <footer className="bg-[#1E293B] text-white py-8 px-6 mt-16">
        <div className="max-w-4xl mx-auto text-center text-sm text-gray-400">
          © {new Date().getFullYear()} WebWerk Kelsterbach. Alle Rechte vorbehalten.
        </div>
      </footer>
    </div>
  );
};

export default Impressum;